/*
 *  ~ Copyright (c) by INFODATA-GROUP. All rights reserved.
 *  ~ No part of this publication may be reproduced, distributed,
 *  ~ or transmitted in any form or by any means, including photocopying, recording,
 *  ~ or other electronic or mechanical methods, without the prior written permission of the publisher,
 *  ~ except in the case of brief quotations embodied in critical
 *  ~ reviews and certain other noncommercial uses permitted by copyright law.
 *  ~ Author : BS
 *  ~ Date : 2/24/23, 2:23 PM
 */

import { AoSharedTools } from '../../engine/tools/ao-shared-tools';
import { ReportTypeEnum } from '../../enum/report-type.enum';
import { AoReport } from './ao-report';
import { AoReportMaterial } from './ao-report-material';

export class AoReportCumulative {
  private _totalTime = 0; // duration in seconds
  public get totalTime(): string {
    return AoSharedTools.convertSecondsDurationToString(this._totalTime);
  }
  private _totalMovement = 0; // duration in seconds
  public get totalMovement(): string {
    return AoSharedTools.convertSecondsDurationToString(this._totalMovement);
  }
  private _totalSite = 0; // duration in seconds
  public get totalSite(): string {
    return AoSharedTools.convertSecondsDurationToString(this._totalSite);
  }
  private _totalBreak = 0; // duration is seconds
  public get totalBreak(): string {
    return AoSharedTools.convertSecondsDurationToString(this._totalBreak);
  }
  private _totalKm = 0; // Km
  public get totalKm(): number {
    return this._totalKm;
  }
  private _averageSpeed = 0; // Km/h
  public get averageSpeed(): number {
    return this._averageSpeed;
  }
  private _maxSpeed = 0; // Km/h
  public get maxSpeed(): number {
    return this._maxSpeed;
  }
  private _totalSuddenBraking = 0;
  public get totalSuddenBraking(): number {
    return this._totalSuddenBraking;
  }
  private _totalSuddenAccelerations = 0;
  public get totalSuddenAccelerations(): number {
    return this._totalSuddenAccelerations;
  }
  private _averageDriverSide = 0;
  public get averageDriverSide(): number {
    return this._averageDriverSide;
  }
  public employeeId = '';
  public employee = '';
  public type: ReportTypeEnum;
  public materialId: string;
  public material = '';

  constructor(report: AoReport) {
    if (report instanceof AoReport) {
      this.employee = report.sal;
      this.employeeId = report.salId;
      this.type = ReportTypeEnum.employee;
    }
    if (report instanceof AoReportMaterial) {
      this.materialId = report.materialId;
      this.material = report.materialLabel;
      this.type = ReportTypeEnum.material;
    }
    this._averageSpeed = report.vitesseMoyenne;
    this._averageDriverSide = report.coteConducteur;
    this.addReport(report);
  }
  public addReport(report: AoReport): void {
    this._totalKm += report.km;
    this._totalSuddenBraking += report.freinageBrutaux;
    this._totalSuddenAccelerations += report.accelerationBrutales;
    if (report.vitesseMaximum > this._maxSpeed) {
      this._maxSpeed = report.vitesseMaximum;
    }
    this._averageSpeed = Math.round(
      (this._averageSpeed + report.vitesseMoyenne) / 2,
    );
    this._averageDriverSide = Math.round(
      (this._averageDriverSide + report.coteConducteur) / 2,
    );
    this._totalTime += AoSharedTools.convertStringDurationToSeconds(
      report.totalTemps,
    );
    this._totalMovement += AoSharedTools.convertStringDurationToSeconds(
      report.totalDeplacement,
    );
    this._totalSite += AoSharedTools.convertStringDurationToSeconds(
      report.totalChantier,
    );
    if (report.type === ReportTypeEnum.employee) {
      this._totalBreak += AoSharedTools.convertStringDurationToSeconds(
        report.totalPause,
      );
    }
  }
}
